import Vue from 'vue';

export default class AddressValidator {

    /**
     *
     * @param {Address} address
     */
    constructor(address) {
        this.errors = {};
        this.address = address;
    }

    flushError(name) {
        Vue.set(this.errors, name, "");
    }

    validateName() {
        this.flushError('name');
        if(!this.address.name) {
            Vue.set(this.errors, 'name', 'page_setcontact.error.companymissing');
        }
    }

    validateAddress() {
        this.flushError('address');
        if(!this.address.street1 && !this.address.street2) {
            Vue.set(this.errors, 'address', 'page_setcontact.error.addressmissing');
        }
    }

    validateZip() {
        this.flushError('zip');
        if(!this.address.zip) {
            Vue.set(this.errors, 'zip', 'page_setcontact.error.zipmissing');
        }
    }

    validateCity() {
        this.flushError('city');
        if(!this.address.city) {
            Vue.set(this.errors, 'city', 'page_setcontact.error.citymissing');
        }
    }

    validateCountry() {
        this.flushError('country');
        if(!this.address.country) {
            Vue.set(this.errors, 'country', 'page_setcontact.error.countrymissing');
        }
    }

    validateAll() {
        this.validateName();
        this.validateAddress();
        this.validateZip();
        this.validateCity();
        this.validateCountry();
    }
}